<template>
  <div class="search-box">
    <div class="search-top">
      <div
        class="left-arrow"
        @click="onClickLeft"
      ></div>
      <div class="s-top-mid">
        <img
          class="search-icon"
          src="../assets/search@2x.png"
        >
        <!-- <input
          type="text"
          placeholder="请输入关键词搜索全景图"
          v-model="keywords"
          v-on:input="getInput()"
        > -->
        <form
          @submit.prevent="formSubmit"
          action="javascript:return true;"
          style="width:100%;text-align:left;"
        >
          <input
            placeholder="请输入关键词搜索全景图"
            v-model="keywords"
            v-on:input="getInput()"
            @keydown="onSearchIcon2($event)"
            type="search"
            ref="input1"
          >
        </form>
      </div>
      <div
        class="s-top-right"
        @click="keywords && searchFlag ? cancel() : goSearch()"
      >{{keywords && searchFlag ? '取消' : '搜索'}}</div>
    </div>
    <div
      id="boxFixed"
      class="search-middle"
      v-if="searchList.length > 0"
    >
      <div
        class="search-m-li"
        v-for="(item,index) in searchList"
        :key="index"
        @click="goDetail(item)"
      >
        <img
          class="search-m-li-l"
          :src="item.coverUrl"
          alt=""
        >
        <div class="search-m-li-r">
          <p
            class="title"
            v-hightlight:[item.title]='keywords'
          >{{item.title}}</p>
          <div class="label">
            <p
              class="label-li"
              v-for="(item2,index2) in item.keywords"
              :key="index2"
              v-hightlight:[`·${item2}`]='keywords' 
            >
              {{item2}}</p>
          </div>
        </div>
      </div>
    </div>
    <div
      class="search-none"
      v-else-if="searchFlag && loadshow === false && searchList.length === 0"
    >
      <img
        src="../assets/noneSearch@2x.png"
        alt=""
      >
    </div>

    <!-- loading -->
    <!-- <van-loading
      type="spinner"
      color="#9D1D22"
      size="44"
      v-if="showLoading"
    /> -->
    <van-overlay :show="loadshow">
      <div class="wrapper" @click.stop>
        <van-loading size="50px" vertical color="#9D1D22"></van-loading>
      </div>
    </van-overlay>
  </div>
</template>

<script>
export default {
  name: "search",
  beforeRouteEnter(to, from, next) {
    // 添加背景色
    document
      .querySelector("body")
      .setAttribute("style", "background-color:#fff");
    next();
  },
  data() {
    return {
      loadshow:false,
      searchFlag: false,
      keywords: "",
      searchList: [], //搜索列表
      offsetTop: 0,
      pageNum: 1, //当前页数
      pageSize: 20,
      totalNum: 1, //总页数
      lastPageNum: 1,
      showLoading: false,
    };
  },
  created() {
    this.searchList.forEach((element) => {
      element.label = element.label.split(",");
    });
    document.title = "全景图搜索";
  },
  mounted() {},
  methods: {
    onClickLeft() {
      this.$router.go(-1); //返回上一层
    },
    // 获取列表
    getContentList() {
      let that = this;
      // that.showLoading = true;
      that.loadshow = true;
      return new Promise(function(resolve, reject) {
        that.$api.article
          .getContentList({
            keyword: that.keywords,
            propertyId: "",
            classPropertyId: "",
            pageIndex: that.pageNum,
            pageSize: that.pageSize,
          })
          .then((res) => {
            // if (res.data.data.list) {
            //   res.data.data.list.forEach((element) => {
            //     element.summary = element.summary.split(" ");
            //     // console.log("item", element.summary);
            //   });
            // }
            if (res.data.data.list) {
              res.data.data.list.forEach((item) => {
                item.keywords = item.keywords.slice(0,3);
              });
            }
            if (that.pageNum === 1) {
              that.searchList = res.data.data.list;
              that.pageNum = res.data.data.pageNum; //获取当前页数
              that.totalNum = res.data.data.pages; //获取总页数
            } else {
              that.searchList = [...that.searchList, ...res.data.data.list];
            }
            ++that.pageNum;
            // that.showLoading = false;
            resolve(res.data.data);
          })
          .catch((err) => {
            that.lastPageNum = that.lastPageNum - 1;
            // that.showLoading = false;
            reject();
          })
          .finally((all) => {
            // that.showLoading = false;
            that.loadshow = false;
          });
      });
    },
    formSubmit() {
      return false;
    },
    onSearchIcon2(e) {
      if (e.keyCode == 13) {
        this.searchFlag = true;
        this.pageNum = 1;
        this.getContentList();
      }
    },
    getInput() {
      if (this.keywords === "") {
        this.searchList = [];
        this.searchFlag = false;
        // this.getContentList()
      }
    },
    goSearch() {
      let that = this;
      that.searchFlag = true;
      that.pageNum = 1;
      that.getContentList().then((res) => {
        if (res.list.length > 0) {
          window.addEventListener("scroll", that.initHeight);
          that.$nextTick(() => {
            //获取对象相对于版面或由 offsetTop 属性指定的父坐标的计算顶端位置
            that.offsetTop = document.querySelector("#boxFixed").offsetTop;
          });
        }
      });
    },
    cancel() {
      this.searchFlag = false;
      this.keywords = "";
      this.searchList = [];
    },
    goDetail(e) {
      this.$router.push({
        path: "/detailLink",
        query: { 
          shareId: e.id,
          timeNum: new Date().getTime()   
        },
      });
    },
    initHeight() {
      // 设置或获取位于对象最顶端和窗口中可见内容的最顶端之间的距离 (被卷曲的高度)
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      //如果被卷曲的高度大于吸顶元素到顶端位置 的距离
      this.isFixed = scrollTop > this.offsetTop ? true : false;

      // 是否滚动到底部
      var scrollTop2 =
        document.documentElement.scrollTop || document.body.scrollTop;
      var windowHeitht =
        document.documentElement.clientHeight || document.body.clientHeight;
      var scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      //是否滚动到底部的判断
      if (scrollTop2 + windowHeitht >= scrollHeight - 50) {
        if (this.pageNum > this.totalNum) {
          return;
        } else {
          if (this.pageNum != this.lastPageNum) {
            this.lastPageNum = this.pageNum; //更新lastPageNum
            this.getContentList();
          }
        }
      }
    },
  },
  //回调中移除监听
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
<style>
.van-overlay{
  z-index: 9;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
input[type="search"]::-webkit-search-cancel-button {
  -webkit-appearance: none; /*此处只是去掉默认的小×*/
}
/*设置placeholder的字体颜色*/
input::-webkit-input-placeholder {
  /* WebKit browsers 适配谷歌 */
  color: #000 !important;
  opacity: 0.5;
}
input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 适配火狐 */
  color: #000 !important;
  opacity: 0.5;
}
input::-moz-placeholder {
  /* Mozilla Firefox 19+ 适配火狐 */
  color: #000 !important;
  opacity: 0.5;
}
input:-ms-input-placeholder {
  /* Internet Explorer 10+  适配ie*/
  color: #000 !important;
  opacity: 0.5;
}
</style>

<style scoped>
.left-arrow {
  width: 14px;
  height: 14px;
  border-top: 2px solid #343434;
  border-right: 2px solid #343434;
}
.search-top {
  font-size: 14px;
  display: flex;
  align-items: center;
  padding: 11px 13px 0 20px;
  justify-content: space-between;
  margin-bottom: 20px;
}
.s-top-mid {
  width: 278px;
  height: 34px;
  line-height:34px;
  background: #ebebeb;
  border-radius: 34px;
  display: flex;
  align-items: center;
}

.search-icon {
  width: 22px;
  height: 22px;
  margin: 0 10px;
}
input {
  height: 100%;
  background-color: #ebebeb;
  color: #000;
  width:100%;
}
.s-top-right {
  color: #9e1e22;
}
.search-none {
  margin-top: 91px;
}
.search-none img {
  width: 186px;
  height: auto;
}
.search-middle {
  padding: 0 15px;
}
.search-m-li {
  display: flex;
  border-bottom: 1px solid #cccccc;
  padding: 15px 0;
}
.search-m-li-l {
  width: 80px;
  height: 80px;
  border-radius: 12px;
  margin-right: 20px;
  flex-shrink: 0;
}
.search-m-li-r {
  display: flex;
  flex-direction: column;
  text-align: left;
  padding: 5px 0 5px 0;
  width:100%;
}
.search-m-li-r .title {
  color: #000000;
  font-size: 14px;
  line-height: 16px;
  width:100%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-all;
}
.search-m-li-r .label-li {
  color: #9a9a9a;
  font-size: 12px;
  line-height: 14px;
  /* margin-top: 5px; */
}

.search-m-li-r .label {
  margin-top: 13px;
}
</style>

